<template>
  <div class="modal">
    <div class="modal-info">
      <p>The "Controls" wizard is designed for one spin only. Other assets will be removed from the gallery.</p>
      <div class="modal-actions">
        <a
          href="#"
          class="btn cancel"
          @click.prevent="close"
        >Cancel</a>
        <a
          href="#"
          class="btn accept"
          @click.prevent="accept"
        >Proceed</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalSpinControlPanel',
  methods: {
    close() {
      this.$store.dispatch('spinControl/changeSpinControlModalStatus', false)
      this.$store.dispatch('spinControl/changeSpinControlModalApprove', false)
    },
    accept() {
      this.$store.dispatch('spinControl/changeSpinControlModalStatus', false)
      this.$store.dispatch('spinControl/changeSpinControlModalApprove', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  z-index: 19999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-info {
  position: relative;
  max-width: 500px;
  width: 100%;
  background-color: #fff;
  min-height: 150px;
  z-index: 2000;
  padding: 40px 30px;
  box-shadow: 0 8px 40px rgba(50, 123, 186, .16), 0 4px 4px rgba(50, 123, 186, .08);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .modal-actions {
    display: flex;
  }

  p {
    margin-bottom: 25px;
  }

  a {
    display: inline-block;
    background-color: #fff;
    border-radius: 4px;
    background-color: #327bba;
    color: #fff;
    margin: 0 10px 10px;
    padding: 4px 10px;
    text-align: center;
    border: 1px solid #327bba;
    cursor: pointer;
    -webkit-transition: background-color .5s ease, color .5s ease;
    transition: background-color .5s ease, color .5s ease, opacity .5s ease;
    text-decoration: none;

    &.cancel {
      background-color: #f5f6f9;
      color: #2f363f;
      border-color: #f5f6f9;
    }
    &.hover {
      opacity: .8;
    }
  }
}
</style>
